// Import 3rd-party dependencies
import { NgModule } from '@angular/core';

// Import project-specific dependencies
import { TrackingDirective } from '@app/directives/tracking.directive';
import { TooltipDirective } from '@app/directives/tooltip.directive';
import { InputClearDirective } from '@app/directives/input-clear.directive';

@NgModule({
  imports: [],
  declarations: [TrackingDirective, TooltipDirective, InputClearDirective],
  exports: [TrackingDirective, TooltipDirective, InputClearDirective]
})
export class DirectivesModule {}
